module.exports = __webpack_public_path__ + "img/copy.a89805aa.png";